import { createFileRoute } from '@tanstack/react-router';
import { CtaButtonContext } from '@/components/astro/cta-button/cta-button';
import { AutoSkipCitationsSection } from '@/components/astro/new-design/sections/auto-skip-citations';
import { BrandLogosSection } from '@/components/astro/new-design/sections/brand-logos';
import { CustomerTestimonialsShortSection } from '@/components/astro/new-design/sections/customer-testimonials-short';
import { EduBannerSection } from '@/components/astro/new-design/sections/edu-banner';
import { FaqSection } from '@/components/astro/new-design/sections/faq';
import { FeaturesCardSection } from '@/components/astro/new-design/sections/features-card';
import { HeroHeadingContactSection } from '@/components/astro/new-design/sections/hero-heading-contact';
import { PricingComparisonSection } from '@/components/astro/new-design/sections/pricing-comparison';
import { ProductOverflowImageSection } from '@/components/astro/new-design/sections/product-overflow-image';
import { SaveTimeByChoosingSection } from '@/components/astro/new-design/sections/save-time-by-choosing';
import { SoundsNaturalEvenAtSpeedSection } from '@/components/astro/new-design/sections/sounds-natural-even-at-speed';
import { TakeNotesOnTheGoSection } from '@/components/astro/new-design/sections/take-notes-on-the-go';
import { VoiceDemoSection } from '@/components/astro/new-design/sections/voice-demo';
import { WhatDoPeopleThinkSection } from '@/components/astro/new-design/sections/what-do-people-think';
import { WorldClassListeningSection } from '@/components/astro/new-design/sections/world-class-listening';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/_legacy/edu')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Listening App for Educational Institutions',
        description:
          'Transform academic research into engaging audio and listen anywhere. Download the Listening app now and start a new learning journey',
      }),
    ],
    scripts: [
      {
        type: 'text/javascript',
        src: 'https://firebasestorage.googleapis.com/v0/b/leadmonk-prod.appspot.com/o/leadmonk%2Fembed%2Fformembed.js?alt=media',
        async: true,
      },
    ],
  }),
  component: EduPage,
});

function EduPage() {
  return (
    <CtaButtonContext
      value={{
        href: '#book-a-demo',
        label: 'Book a Demo',
        analyticsCheckout: false,
      }}
    >
      <div className='absolute inset-x-0 top-0 h-[30vh] bg-[linear-gradient(rgba(21,_112,_239,_.2),_rgba(255,_255,_255,_0))]' />
      <NavBar />
      <HeroHeadingContactSection />
      <EduBannerSection />
      <BrandLogosSection />
      <VoiceDemoSection />
      <CustomerTestimonialsShortSection />
      <ProductOverflowImageSection />
      <WorldClassListeningSection />
      <TakeNotesOnTheGoSection />
      <AutoSkipCitationsSection />
      <SaveTimeByChoosingSection />
      <SoundsNaturalEvenAtSpeedSection />
      <WhatDoPeopleThinkSection />
      <PricingComparisonSection />
      <FeaturesCardSection />
      <FaqSection />
      <Footer />
    </CtaButtonContext>
  );
}
